import React, { useState } from "react";
import { toast } from "react-toastify";
import "../../css/delivery-form.css";
import photo2 from "../../img/photo-2.jpg";
import { Form, Button } from "react-bootstrap";
import axios from "axios";
import { API_URL_All } from "../../api";

const QuoteSection = () => {
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [content, setContent] = useState("");

  const handleFullNameChange = (e) => {
    setFullName(e.target.value);
  };

  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleContentChange = (e) => {
    setContent(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!fullName || !phoneNumber || !content) {
      toast.error("Vui lòng điền đầy đủ thông tin", { position: "top-right" });
      return;
    }

    try {
      const contactData = {
        name: fullName,
        numberPhone: phoneNumber,
        email: email,
        message: content,
      };

      const response = await axios.post(`${API_URL_All}/api/contact-exploration/create`, contactData);

      if (response.data.success) {
        toast.success("Đăng ký nhận báo giá thành công!", {
          position: "top-right",
        });
        
        // Reset form
        setFullName("");
        setPhoneNumber("");
        setEmail("");
        setContent("");
      }
    } catch (error) {
      console.error("Error submitting quote form:", error);
      toast.error("Có lỗi xảy ra khi gửi thông tin. Vui lòng thử lại!", {
        position: "top-right",
      });
    }
  };

  return (
    <section className="quote-section">
      <div className="container p-0">
        <div className="row">
          <div className="col-md-6 bg-zto d-flex flex-column align-items-center">
            <h2 className="text-white text-center fw-bold mt-4 mb-5">
              Đăng ký nhận báo giá
            </h2>
            <Form onSubmit={handleSubmit} className="w-75 text-center">
              <Form.Group controlId="formFullName" className="mb-4">
                <Form.Control
                  type="text"
                  placeholder="Họ và tên*:"
                  value={fullName}
                  onChange={handleFullNameChange}
                  required
                />
              </Form.Group>
              <Form.Group controlId="formPhoneNumber" className="mb-4">
                <Form.Control
                  type="text"
                  placeholder="Số điện thoại*:"
                  value={phoneNumber}
                  onChange={handlePhoneNumberChange}
                  required
                />
              </Form.Group>
              <Form.Group controlId="formEmail" className="mb-4">
                <Form.Control
                  type="email"
                  placeholder="Email:"
                  value={email}
                  onChange={handleEmailChange}
                />
              </Form.Group>
              <Form.Group controlId="formContent" className="mb-4">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Nội dung*:"
                  value={content}
                  onChange={handleContentChange}
                  required
                />
              </Form.Group>
              <Button
                type="submit"
                className="btn btn-success w-50 rounded-pill border-0 btn-consultation"
                style={{ background: "rgb(155, 201, 84)", padding: "0.75rem" }}
              >
                Gửi thông tin
              </Button>
            </Form>
          </div>
          <div className="col-md-6 p-0">
            <img
              src={photo2}
              alt="Delivery Illustration"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuoteSection;
